const axios = require('axios');

(() => {
  const registerCreditcardButton = '.register-camping-subscription-creditcard-button'
  const creditcardIndexPath = process.env.JS_BASE_URL + 'customer/mypage/camping_subscription/history';

  const init = () => {
    $('body')
      .on('click', registerCreditcardButton, registerCreditcard);
    const memberId = $('#data-current-user-member-id').data('member')

    if (location.pathname === creditcardIndexPath && memberId !== null) {
      inquiryRegisteredCreditcardInfo();
    }
  }

  const fetchCreditCardInfo = async () => {
    try {
      return await axios.get(process.env.JS_BASE_URL + 'api/v1/credit_card_sessions');
    } catch (error) {
      console.log(error);
    }
  }

  const registerCreditcard = async e => {
    e.preventDefault();
    $(registerCreditcardButton).addClass('disabled').prop('disabled', true);
    const response = await fetchCreditCardInfo();

    const holderName = response.data.holder_name;
    const cardNumber = response.data.card_number;
    const cardNumberString = String(cardNumber);
    const ExpirationMonth = response.data.card_expiration_month;
    const ExpirationYear = response.data.card_expiration_year;
    const securityCode = response.data.security_code;
    const securityCodeString = String(securityCode);
    const twoDigitExpirationMonth = ('0' + ExpirationMonth).slice(-2)
    const reservationType = response.data.reservation_type;
    let expireMmyy = String(ExpirationYear) + String(twoDigitExpirationMonth);

    var gmoShopId = gon.gmo_shop_id;
    Multipayment.init(gmoShopId);
    Multipayment.getToken({
      cardno : cardNumberString,
      expire : expireMmyy,
      securitycode : securityCodeString,
      holdername : holderName,
    }, (response) => {
      if (response.resultCode != '000') {
        $(registerCreditcardButton).removeClass('disabled').prop('disabled', false);
        alert('クレジットカードが無効です');
      } else {
        let token = response.tokenObject.token;
        var targetUrl = process.env.JS_BASE_URL + 'customer/camping_subscription/registration';

        axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content')
        axios.post(targetUrl, {
          creditcard_token: token
        }).then(response => {
          if (response.status === 200) {
            window.location.href = targetUrl;
          }
        }).catch((error) => {
          $(registerCreditcardButton).removeClass('disabled').prop('disabled', false);
          alert('登録に失敗しました。再度お試し下さい');
        });
      }
    })
  }

  const inquiryRegisteredCreditcardInfo = () => {
    const targetUrl = process.env.JS_BASE_URL + 'api/v1/inquiry_creditcard_registrations?subscription=1';
    axios.get(targetUrl).then(response => {
      if (response.status === 200) {
        const cardNo = response.data.card_info.CardNo;
        const expire = response.data.card_info.Expire;
        const holderName = response.data.card_info.HolderName;
        const expireYear = '20' + String(expire.substr(0, 2));
        const expireMonth = expire.substr(2, 4);
        $('#registered_creditcard_cardno').prepend(`<p>${cardNo}</p>`);
        $('#registered_creditcard_expire').prepend(`<p>有効期限 ${expireMonth}/${expireYear}</p>`);
        $('#registered_creditcard_holdername').prepend(`<p>${holderName}</p>`);
      }
    }).catch(error => {
      console.log(error);
    })
  }
  $(init);
})();
